import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { Toast } from 'vant'
import { ComponentInstance } from 'vant/lib/utils'
import { setLoading } from './helper'
import { reportUrl } from './reportSentry'

export interface ResultType<T> {
  data: T
  code: string | number
  msg: string
  message?: string
}

function createService(
  options: AxiosRequestConfig,
  loading = false,
  toasting = false
) {
  let toast: ComponentInstance | null = null
  const service = axios.create(options)
  service.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      if (loading) {
        setLoading(true)
      }
      if (toasting) {
        toast = Toast.loading({
          forbidClick: true,
          duration: 0
        })
      }
      return config
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )
  service.interceptors.response.use(
    (response: AxiosResponse) => {
      if (loading) {
        setLoading(false)
      }
      if (toasting && toast) {
        toast.clear()
        toast = null
      }
      // 业务接口返回错误暂且不再上报
      // if (response && response.config && response.config.url) {
      //   reportUrl(response)
      // }
      const res: ResultType<any> =
        response && response.data ? response.data : response
      return res || {}
    },
    (error: AxiosError) => {
      if (loading) {
        setLoading(false)
      }
      if (toasting && toast) {
        toast.clear()
        toast = null
      }
      if (error.isAxiosError) {
        reportUrl(error.response, true)
      }
      return Promise.reject(error)
    }
  )
  return service
}

/* 带cookie */
const $http = createService({ withCredentials: true })
export const http = $http

/* 带cookie、带loading */
const $lHttp = createService({ withCredentials: true }, true, false)
export const lHttp = $lHttp

/* 带cookie、带toast */
const $tHttp = createService({ withCredentials: true }, false, true)
export const tHttp = $tHttp

/* 不带cookie */
const $ajax = createService({ withCredentials: false })
export const ajax = $ajax

/* 不带cookie、带loading */
const $lAjax = createService({ withCredentials: false }, true, false)
export const lAjax = $lAjax

/* 不带cookie、带toast */
const $tAjax = createService({ withCredentials: false }, false, true)
export const tAjax = $tAjax
